// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kbff","fullView":"styles_fullView__1PFdx"};